<template>
  <div class="animated fadeIn">
    <button @click="openDoc" class="btn-primary w-100">Open Pending Documents</button>
    <!-- <b-modal class="modal-custom-privy" hide-footer v-model="modalShow" centered title="Checkout">
      <div class="container-iframe">
        <iframe id="privyFrame" v-show="linkPrivyId" :src="linkPrivyId" class="w-100" frameborder="0"></iframe>
      </div>
    </b-modal> -->
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import moment from 'moment'

export default {
  name: 'addbranch',
  data: function () {
    return {
      // modalShow: true,
      linkDataPrivy: '',
      linkPrivyId: 'https://web.privy.id/',
      errorMoney: 'The amount field is required!',
      formType: null,
      options: [
        { value: null, text: 'Please select' },
        { value: 'freeze', text: 'Freeze' },
        { value: 'cancel', text: 'Cancel' },
        { value: 'outstanding', text: 'Outstanding' },
        { value: 'wristband', text: 'Wristband' },
        { value: 'lostAndFound', text: 'Lost & Found' },
        { value: 'dailyVisit', text: 'Daily Visit' },
        { value: 'grabAndGo', text: 'Grab & Go' }
      ]
    }
  },
  methods: {
    openDoc () {
      var baseUrl = window.location.origin
      this.linkDataPrivy = window.open(baseUrl + '/loading')
      this.linkDataPrivy.location = this.linkPrivyId
    },
    changeFormType (event) {
      if (event === 'freeze') {
        this.$router.push('/allForm/addFreeze')
      } else if (event === 'cancel') {
        this.$router.push('/allForm/addCancel')
      } else if (event === 'outstanding') {
        this.$router.push('/allForm/addOutstanding')
      } else if (event === 'wristband') {
        this.$router.push('/allForm/addWristband')
      } else if (event === 'lostAndFound') {
        this.$router.push('/allForm/addLostAndFound')
      } else if (event === 'dailyVisit') {
        this.$router.push('/allForm/addDailyVisit')
      } else if (event === 'grabAndGo') {
        this.$router.push('/allForm/addGrabAndGo')
      } else {
        this.$router.push('/allForm/add')
      }
    },
    openPage (event) {
      this.$router.push(event)
    },
    fetchData() {
      axios.get('fitness/v1/member/').then(response => {
        this.dataMember = response.data.data.rows
        // console.log('test', response)
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created () {
    this.fetchData()
  }
}
</script>

<style>
</style>
